import { FeatureFlagKey } from "@epicbrief/shared/types"
import { isTestRun } from "@epicbrief/shared/utils/config"
import { useFeatureFlagEnabled } from "posthog-js/react"

export const useFeatureFlag = (featureFlag: FeatureFlagKey): boolean => {
  if (isTestRun()) return true

  const isActive = useFeatureFlagEnabled(featureFlag)

  return !!isActive
}
